import './widgets.scss';

import ThimEkitsTab from './widgets/js/tabs';
import thimEkitsMiniCart from './widgets/js/mini-cart';
import thimEkitsModal from './widgets/js/modal';
// import thimEkitsGridListPosts from './widgets/js/gridlist';
import ThimSlider from './widgets/js/thim-slider';
import ThimCountDown from './widgets/js/countdown';
// When release LP version 4.2.6 along time, we will comment these line.
// It handle for old version of Thim El Kit < 1.1.8
import thimArchiveCourse from './widgets/js/archive-course';
import thimEkitLoadMoreArchive from './widgets/js/archive-loadmore';
// When release LP version 4.2.6 along time, we will comment these line.
import thimCopyToClipboard from './widgets/js/copy-to-clipboard';
import thimEkitReading from './widgets/js/reading-time-post';

// import thimEkitsTriggerOrderby from './widgets/js/orderby';
// import thimEkitsGridList from './widgets/js/gridlist-course';
// import thimEkitsOfferEnd from './widgets/js/offerend';

/**
 * Motion Effects
 */
import MotionEffects from './widgets/js/motion-effects';

import { getOffsetPopupHeaderHeight, getOffsetPopupFooterHeight, stickySidebar } from './widgets/js/course-item-section';
import './widgets/js/list-block-tabs';

import thimDrawSVG from './widgets/js/draw-svg.js';

if (! window.ThimEkits) {
	window.ThimEkits = {
		ThimSlider,
		ThimEkitsTab,
		ThimCountDown,
	};
}

document.addEventListener( 'DOMContentLoaded', () => {
	ThimEkitsTab();
	thimEkitsMiniCart();
	thimEkitsModal();
	thimArchiveCourse();
	//thimEkitsTriggerOrderby();
	// thimEkitsOfferEnd();
	thimEkitReading();
} );

// callback in Elementor Editor.
document.body.addEventListener( 'thimEkitsEditor:init', function() {
	ThimEkitsTab();
	thimEkitsMiniCart();
	thimEkitsModal();
	thimEkitReading();
} );

// callback in Elementor Editor.
document.body.addEventListener( 'thimEkitsEditor:miniCart', thimEkitsMiniCart );

jQuery( window ).on( 'elementor/frontend/init', () => {
	const addHandler = ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( ThimSlider, {
			$element,
		} );
		elementorFrontend.elementsHandler.addHandler( ThimEkitsTab, {
			$element,
		} );
	};

	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-list-course.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-list-product.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-list-blog.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-post-related.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-course-related.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-testimonial.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-team.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-list-event.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-product-related.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-countdown.default', ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( ThimCountDown, { $element } );
	} );

	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-search-form.default', thimEkitsModal );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-social-share.default', thimCopyToClipboard );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-reading-time-post.default', thimEkitReading );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-loop-product-countdown.default', ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( ThimCountDown, { $element } );
	} );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-course-offer-end.default', ( $element ) => {
		elementorFrontend.elementsHandler.addHandler( ThimCountDown, { $element } );
	} );

	//
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-tab.default', addHandler );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-slider.default', addHandler );

	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-course-item-section.default', ( $element ) => {
		getOffsetPopupHeaderHeight( $element[0] );
		getOffsetPopupFooterHeight( $element[0] );
		stickySidebar( $element[0] );

		// when window resize, get height class ekit-popup-header and set variable.
		window.addEventListener( 'resize', () => {
			getOffsetPopupHeaderHeight( $element[0] );
			getOffsetPopupFooterHeight( $element[0] );
		} );
	} );

	elementorFrontend.hooks.addAction(
		'frontend/element_ready/thim-ekits-archive-course.default',
		( $element ) => {
			thimEkitLoadMoreArchive( '.thim-ekits-archive-course', '.thim-ekits-course__inner' );
		},
	);
	elementorFrontend.hooks.addAction(
		'frontend/element_ready/thim-ekits-archive-post.default',
		( $element ) => {
			thimEkitLoadMoreArchive( '.thim-ekit-archive-post', '.thim-ekit-archive-post__inner' );
		},
	);
	// Icon box draw svg
	elementorFrontend.hooks.addAction( 'frontend/element_ready/thim-ekits-icon-box.default', thimDrawSVG );
	elementorFrontend.hooks.addAction( 'frontend/element_ready/svg-draw.default', thimDrawSVG );

	// Mouse effects.
	// Apply for all widgets.
	elementorFrontend.elementsHandler.attachHandler( 'global', MotionEffects, null );
} );
